<!-- 編集フォーム -->
@if (isEditMode) {
  @if (activeDocumentTab === 'plan') {
    <app-my-event-edit-form
      [eventId]="eventId"
      [documentType]="activeDocumentTab"
      (cancelled)="onCancelEdit()"
    ></app-my-event-edit-form>
  } @else {
    <app-my-report-edit-form
      [eventId]="eventId"
      (cancelled)="onCancelEdit()"
    ></app-my-report-edit-form>
  }
}

<!-- スピナー -->
<!-- @if (!isEditMode && showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}
-->

<!-- メインコンテンツ -->
@if (!isEditMode && eventDetail) {
  <div class="detail-container">
    <!-- 左サイドメニュー -->
    <div class="side-menu">
      <!-- 帳票タブ -->
      <div
        class="document-tab"
        [class.active]="activeDocumentTab === 'plan'"
        (click)="onDocumentTabChange('plan')"
      >
        企画書
      </div>

      @if (canViewReportTab) {
        <div
          class="document-tab"
          [class.active]="activeDocumentTab === 'report'"
          (click)="onDocumentTabChange('report')"
        >
          報告書
        </div>
      }
    </div>

    <!-- メインエリア -->
    <div class="main-area" #mainArea [style.min-height.px]="mainAreaMinHeight">

      <!-- パンくず：一覧に戻る -->
      <nav class="breadcrumb">
        <a class="breadcrumb-link" (click)="onClose()">一覧に戻る</a>
      </nav>

      <!-- 1439px以下：左の列の代わりに、企画書・報告書の切り替えを本文の先頭にタブで出す（企画書だけの場合も企画書のタブを出す） -->
      <div class="document-tabs-top">
        <button
          type="button"
          class="document-tab-top"
          [class.active]="activeDocumentTab === 'plan'"
          (click)="onDocumentTabChange('plan')"
        >企画書</button>
        @if (canViewReportTab) {
          <button
            type="button"
            class="document-tab-top"
            [class.active]="activeDocumentTab === 'report'"
            (click)="onDocumentTabChange('report')"
          >報告書</button>
        }
      </div>

      @if (showSpinner) {
        <div class="spinner">
          <mat-spinner diameter="60"></mat-spinner>
        </div>
      } @else {
        <!-- ヘッダー -->
        <div class="detail-header">
          <h2 class="document-type-title">
            {{ activeDocumentTab === 'plan' ? '企画書' : '報告書' }}
          </h2>
          <span class="status-badge" [class]="'status-' + eventDetail.status">
            {{
              eventDetail.documentType === 'report'
                && activeDocumentTab === 'plan'
                  ? getStatusLabel('completed')
                  : getStatusLabel(eventDetail.status)
            }}
          </span>

          <!-- 編集・削除ボタン：見出しと同じ行の右端に横に並べる -->
          <div class="header-actions">
            @if (
              canDelete &&
              !(
                eventDetail.documentType === 'report' &&
                activeDocumentTab === 'plan'
              )
            ) {
              <button
                mat-raised-button
                class="delete-btn"
                (click)="onDelete()"
              >
                削除
              </button>
            }
            @if (canEdit) {
              <button
                mat-raised-button
                class="edit-btn"
                (click)="onEdit()"
              >
                編集
              </button>
            }
          </div>
        </div>

        <!-- プレビュータブ -->
        <div class="preview-section">
          <div class="preview-tabs-wrapper">
            <div class="preview-tabs">
              <button
                class="preview-tab"
                [class.active]="activePreviewTab === 'self'"
                (click)="onPreviewTabChange('self')"
              >
                自組織プレビュー
              </button>
              <button
                class="preview-tab"
                [class.active]="activePreviewTab === 'other'"
                (click)="onPreviewTabChange('other')"
              >
                他組織プレビュー
              </button>
            </div>
          </div>

          <!-- プレビューコンテンツ -->
          <div class="preview-content" #previewContent [style.min-height.px]="previewMinHeight">
            <!-- プレビュー（自組織・他組織共通）。タイトルとカテゴリーを先頭に出し、その下は内容ごとのカード（見出しの帯＋項目名と内容の行）に分ける。
                 中の項目がない場合は、見出し・カードごと出さない。
                 単一選択・テキスト入力は枠で囲わず、大項目（対象単位など）・複数選択は枠で囲う。順位のある複数選択は番号付き（1-3位形式）。
                 他組織プレビューでは、自組織だけに見せる項目（詳細の箇条書き・外部業者の担当者と連絡先・金額・資料・メモなど）を出さない -->
            @if (activeDocumentTab === 'plan') {
              @if (!planPreviewReady) {
                <div class="spinner">
                  <mat-spinner diameter="60"></mat-spinner>
                </div>
              } @else if (isOtherPreview && (planForm.categoryId === 8 || planForm.categoryId === 9)) {
                <div class="no-preview">
                  他組織に公開されません。
                </div>
              } @else {
                <div class="plan-preview-wrap pv">

                  <div class="pv-head">
                    <h3 class="pv-title">
                      @if (planForm.title) {
                        {{ planForm.title }}
                      } @else {
                        <span class="unregistered">タイトル 未登録</span>
                      }
                    </h3>
                    <div class="pv-chips" appStackOnWrap>
                      @if (categoryMajorName) {
                        <span class="pv-major">{{ categoryMajorName }}</span>
                      }
                      @if (!isInitialState) {
                        @for (sub of getPlanMasterNameArray(planForm.categorySub, 'category_sub'); track sub; let i = $index) {
                          <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ sub }}</span>
                        } @empty {
                          <span class="unregistered">中分類 未登録</span>
                        }
                      }
                    </div>
                  </div>

                  @if (!isInitialState) {
                    <!-- コンセプト -->
                    <section class="pv-card pv-card-concept" style="--pv-label-chars: 7">
                      <div class="pv-card-title">コンセプト</div>

                      <div class="pv-row stack">
                        <div class="pv-label">企画の概要</div>
                        <div class="pv-value">
                          @if (planForm.summary) {
                            <div class="pv-text">{{ planForm.summary }}</div>
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                      </div>

                      @if (planShowIssueSection) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">目的</div>
                          <div class="pv-value">
                            <span class="pv-chip num pv-min-ghost" aria-hidden="true"><span class="priority-num">1</span>{{ conceptLongestOptionName }}</span>
                            <div class="pv-chips" appStackOnWrap>
                              @for (purpose of getPlanMasterNameArray(planForm.purpose, 'purpose'); track purpose; let i = $index) {
                                <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ purpose }}</span>
                              } @empty {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        </div>

                        <!-- 改善したい指標（状態の変化）は見出しなしで1-3位形式。企画の成果は「成果目標」として別の行に分ける -->
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">改善したい指標</div>
                          <div class="pv-value">
                            <span class="pv-chip num pv-min-ghost" aria-hidden="true"><span class="priority-num">1</span>{{ conceptLongestOptionName }}</span>
                            <div class="pv-chips" appStackOnWrap>
                              @for (state of getPlanMasterNameArray(planForm.improvementIndicatorState, 'improvement_indicator_state'); track state; let i = $index) {
                                <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ state }}</span>
                              } @empty {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        </div>

                        @if (planShowTargetOrg) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">成果目標</div>
                            <div class="pv-value">
                              @if (planForm.improvementIndicatorOutcome) {
                                <div class="pv-chips" appStackOnWrap>
                                  <span class="pv-chip">{{ getPlanMasterName('improvement_indicator_outcome', planForm.improvementIndicatorOutcome) }}</span>
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                      }

                      @if (planShowSocialTheme) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">社会テーマ</div>
                          <div class="pv-value">
                            <span class="pv-chip num pv-min-ghost" aria-hidden="true"><span class="priority-num">1</span>{{ conceptLongestOptionName }}</span>
                            <div class="pv-chips" appStackOnWrap>
                              @for (social of getPlanMasterNameArray(planForm.socialTheme, 'social_theme'); track social; let i = $index) {
                                <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ social }}</span>
                              } @empty {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      <!-- 該当する役職は自組織だけ（previewScopeRoleNames は他組織では null） -->
                      <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                        <div class="pv-label">公開範囲</div>
                        <div class="pv-value">
                          @if (planForm.publicScope) {
                            <div class="pv-chips" appStackOnWrap>
                              <span class="pv-chip">{{ getPlanMasterName('public_scope', planForm.publicScope) }}</span>
                            </div>
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                        @if (previewScopeRoleNames) {
                          <div class="public-scope-roles-inline pv-below">
                            <span class="public-scope-roles-prefix">該当する役職<span class="public-scope-roles-colon">：</span></span>
                            <span class="public-scope-roles-names">
                              @for (name of previewScopeRoleNames; track $index; let last = $last) {
                                <span class="public-scope-role-block">{{ name }}{{ last ? '' : '、' }}</span>
                              }
                            </span>
                          </div>
                        }
                      </div>
                    </section>

                    <div class="pv-grid">
                      <!-- 日程・実施方法 -->
                      <section class="pv-card pv-card-schedule" style="--pv-label-chars: 4">
                        <div class="pv-card-title">日程・実施方法</div>

                        <!-- 開催日：「1日目」「開始」などの見出しは出さず、日付 時間〜時間（実施時間）を日ごとに縦に並べる。
                             期間の場合は、2つの日付の間の行に「から」を日付の中央に置く。
                             会場などと同じく項目名の横に置き、入らなければ項目名の下に落とす。下に落としても1行に入らなければ、日付と時間を2段にする -->
                        <div class="pv-row pv-auto pv-date-row" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">開催日</div>
                          <div class="pv-value">
                            <div class="pv-dates" appStackOnWrap>
                              @for (row of planScheduleRows; track row.index; let first = $first) {
                                @if (planForm.numberOfDays === 'period' && !first) {
                                  <span class="pv-date-from">から</span>
                                  <span></span>
                                }
                                @if (getPlanScheduleDisplay(row.index); as schedule) {
                                  @if (schedule.date || schedule.start || schedule.end) {
                                    <!-- 日付・開始・終了のうち、空のものだけ「未登録」にする（すべて空のときは「未登録」だけ） -->
                                    <span class="pv-date">
                                      @if (schedule.date) {
                                        {{ schedule.date }}
                                      } @else {
                                        <span class="unregistered">未登録</span>
                                      }
                                    </span>
                                    <span class="pv-time">
                                      <span class="pv-nowrap">
                                        @if (schedule.start) {<span>{{ schedule.start }}</span>} @else {<span class="unregistered">未登録</span>}<span> 〜 </span>@if (schedule.end && (!schedule.start || schedule.start <= schedule.end)) {<span>{{ schedule.end }}</span>} @else {<span class="unregistered">未登録</span>}
                                      </span>
                                      @if (schedule.duration) {
                                        <span class="pv-nowrap pv-time-duration">　{{ schedule.duration }}</span>
                                      }
                                    </span>
                                  } @else {
                                    <span class="pv-date"><span class="unregistered">未登録</span></span>
                                    <span></span>
                                  }
                                }
                              }
                            </div>
                          </div>
                        </div>

                        @if (planShowVenue) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">会場</div>
                            <div class="pv-value">
                              {{ getPlanMasterName('venue', planForm.venue) }}
                              <!-- 詳細（施設名・住所など）は任意のため、入っているときだけ会場の下に出す（「未登録」は出さない） -->
                              @if (planForm.venueDetail) {
                                <div class="pv-venue-detail">{{ planForm.venueDetail }}</div>
                              }
                            </div>
                          </div>
                        }

                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">実施方法</div>
                          <div class="pv-value">
                            @if (planForm.implementationMethod) {
                              {{ getPlanMasterName('implementation_method', planForm.implementationMethod) }}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>

                        @if (planShowHoldingMethodRow) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">開催方法</div>
                            <div class="pv-value">
                              @if (planForm.holdingMethod) {
                                {{ getPlanMasterName('holding_method', planForm.holdingMethod) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowEducationFormatRow) {
                          <div class="pv-row pv-auto pv-flow-row" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">教育形式</div>
                            <div class="pv-value">
                              <div class="pv-chips">
                                @for (format of getPlanMultiNames(planForm.educationFormat, 'education_format'); track format) {
                                  <span class="pv-chip">{{ format }}</span>
                                } @empty {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowSurveyMethodRow) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">調査方法</div>
                            <div class="pv-value">
                              @if (planForm.surveyMethod) {
                                {{ getPlanMasterName('survey_method', planForm.surveyMethod) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowMeetingSection) {
                          <div class="pv-row pv-auto pv-flow-row" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">会議体</div>
                            <div class="pv-value">
                              <div class="pv-chips">
                                @for (format of getPlanMultiNames(planForm.meetingFormats, 'meeting_format'); track format) {
                                  <span class="pv-chip">{{ format }}</span>
                                } @empty {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </section>

                      <!-- 対象 -->
                      @if (planShowTargetCard) {
                        <section class="pv-card" style="--pv-label-chars: 6">
                          <div class="pv-card-title">対象</div>

                          @if (planShowEstimatedParticipants) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">想定参加人数</div>
                              <div class="pv-value">
                                @if (planForm.estimatedParticipants !== null && planForm.estimatedParticipants !== undefined) {
                                  <span class="pv-num">{{ planForm.estimatedParticipants }}人</span>
                                  @if (coverageRate) {
                                    <span class="pv-inline-note">カバー率 {{ coverageRate }}</span>
                                  }
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          }

                          @if (planShowTargetOrg) {
                            <!-- 対象組織：単位の名称を枠で囲い、詳細は箇条書き（「単位」「詳細」の見出しは出さない） -->
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">対象組織</div>
                              <div class="pv-value">
                                @if (planForm.targetUnit) {
                                  <div class="pv-chips" appStackOnWrap>
                                    <span class="pv-chip">{{ getPlanMasterName('organizer_org_unit', planForm.targetUnit) }}</span>
                                  </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              @if (!isOtherPreview) {
                                @if (planForm.targetOrgDetailText) {
                                  <div class="pv-bullets pv-below">
                                    @for (line of planForm.targetOrgDetailText.split('\n'); track $index) {
                                      <div class="org-detail-line-wrapper">
                                        <div class="dot">・</div>
                                        <div class="org-detail-line">{{ line }}</div>
                                      </div>
                                    }
                                  </div>
                                } @else {
                                  <div class="pv-bullets pv-below"><span class="unregistered">未登録</span></div>
                                }
                              }
                            </div>

                            <!-- 対象/参加者：カテゴリーの名称を枠で囲い、詳細は箇条書き（「詳細」の見出しは出さない） -->
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">対象/参加者</div>
                              <div class="pv-value">
                                @if (planForm.participantCategory) {
                                  <div class="pv-chips" appStackOnWrap>
                                    <span class="pv-chip">{{ getPlanMasterName('participant_category', planForm.participantCategory) }}</span>
                                  </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              @if (planForm.participantCategory !== 199) {
                                <div class="pv-bullets pv-below">
                                  @if (getPlanParticipantDetailDisplay(); as detail) {
                                    @for (item of detail.split('、'); track $index) {
                                      <div class="org-detail-line-wrapper">
                                        <div class="dot">・</div>
                                        <div class="org-detail-line">{{ item }}</div>
                                      </div>
                                    }
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                              }
                            </div>

                            <!-- 属性：年代→性別の順に枠で囲って横に並べる（「年代」「性別」の見出しは出さない）。
                                 横に入らなければ項目名の下に落とし、それでも入らなければ1つずつ次の行に送る（pv-flow-row） -->
                            @if (getPlanAttrGenerationDisplay() || getPlanAttrGenderDisplay()) {
                              <div class="pv-row pv-auto pv-flow-row" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                <div class="pv-label">属性</div>
                                <div class="pv-value">
                                  <div class="pv-chips">
                                    @for (gen of getPlanMultiNames(planForm.participantAttributes, 'attr_generation'); track gen) {
                                      <span class="pv-chip">{{ gen }}</span>
                                    }
                                    @for (gender of getPlanMultiNames(planForm.participantAttributes, 'attr_gender'); track gender) {
                                      <span class="pv-chip">{{ gender }}</span>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          }

                          @if (planShowMeetingSection) {
                            <div class="pv-row pv-auto pv-flow-row" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">主な相手先</div>
                              <div class="pv-value">
                                <div class="pv-chips">
                                  @for (type of getPlanMultiNames(planForm.counterpartTypes, 'counterpart_type'); track type) {
                                    <span class="pv-chip">{{ type }}</span>
                                  } @empty {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </section>
                      }

                      <!-- 開催者 -->
                      <section class="pv-card" style="--pv-label-chars: 7">
                        <div class="pv-card-title">開催者</div>

                        <!-- 開催者所属：組織の名称を枠で囲い、詳細は箇条書き（「組織」「詳細」の見出しは出さない） -->
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">開催者所属</div>
                          <div class="pv-value">
                            @if (planForm.organizerUnit) {
                              <div class="pv-chips" appStackOnWrap>
                                <span class="pv-chip">{{ getPlanMasterName('organizer_org_unit', planForm.organizerUnit) }}</span>
                              </div>
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                          @if (!isOtherPreview) {
                            @if (planForm.organizerOrgDetailText) {
                              <div class="pv-bullets pv-below">
                                @for (line of planForm.organizerOrgDetailText.split('\n'); track $index) {
                                  <div class="org-detail-line-wrapper">
                                    <div class="dot">・</div>
                                    <div class="org-detail-line">{{ line }}</div>
                                  </div>
                                }
                              </div>
                            } @else {
                              <div class="pv-bullets pv-below"><span class="unregistered">未登録</span></div>
                            }
                          }
                        </div>

                        @if (planShowOtherCollaborationRow) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">他労組共同開催</div>
                            <div class="pv-value">
                              @if (getPlanCompanyOtherCollaborationLabel()) {
                                {{ getPlanCompanyOtherCollaborationLabel() }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowCompanyCollaborationRow) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">会社協働・協賛</div>
                            <div class="pv-value">
                              @if (getPlanCompanyCollaborationLabel()) {
                                {{ getPlanCompanyCollaborationLabel() }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                      </section>

                      <!-- 外部業者（1社ごとにカードを分ける。SPでは1社目だけ出し、2社目以降は「残り○社を表示」で開く）。
                           金額は、自組織は金額だけ、他組織は概算だけを出す -->
                      @for (vendor of previewVendors; track $index; let i = $index) {
                        <section class="pv-card" style="--pv-label-chars: 6" [class.pv-vendor-more]="i > 0 && !showAllVendors">
                          <div class="pv-card-title">外部業者{{ previewVendors.length > 1 ? ' ' + (i + 1) : '' }}</div>
                          @if (vendor.companyName) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">会社/組織名</div>
                              <div class="pv-value">{{ vendor.companyName }}</div>
                            </div>
                          }
                          @if (!isOtherPreview && vendor.contactPerson) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">担当者</div>
                              <div class="pv-value">{{ vendor.contactPerson }}</div>
                            </div>
                          }
                          @if (!isOtherPreview && vendor.contactInfo) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">連絡先</div>
                              <div class="pv-value">{{ vendor.contactInfo }}</div>
                            </div>
                          }
                          @if (vendor.workSummary) {
                            <div class="pv-row stack">
                              <div class="pv-label">担当概要</div>
                              <div class="pv-value"><div class="pv-text">{{ vendor.workSummary }}</div></div>
                            </div>
                          }
                          @if (vendor.workDurationMinutes != null) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">担当時間</div>
                              <div class="pv-value">{{ formatPlanDuration(vendor.workDurationMinutes) }}</div>
                            </div>
                          }
                          @if (vendor.specificCost != null) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">金額</div>
                              <div class="pv-value">
                                @if (isOtherPreview) {
                                  <span class="pv-num">{{ getVendorCostLabel(vendor.specificCost) }}</span>
                                } @else {
                                  <span class="pv-num">{{ formatPlanCurrency(vendor.specificCost) }}円</span>
                                }
                              </div>
                            </div>
                          }
                        </section>
                      }
                      @if (previewVendors.length > 1 && !showAllVendors) {
                        <button type="button" class="pv-more-btn" (click)="showAllVendors = true">
                          ＋ 外部業者をあと{{ previewVendors.length - 1 }}社表示
                        </button>
                      }

                      <!-- 費用 -->
                      @if (planShowCostCard) {
                        <section class="pv-card" style="--pv-label-chars: 6">
                          <div class="pv-card-title">費用</div>

                          @if (planShowCostRow) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">想定費用総額</div>
                              <div class="pv-value">
                                @if (planForm.estimatedTotalCost !== null && planForm.estimatedTotalCost !== undefined) {
                                  <span class="pv-num">{{ formatPlanCurrency(planForm.estimatedTotalCost) }}円</span>
                                  @if (costPerPerson) {
                                    <span class="pv-inline-note">{{ costPerPerson }}</span>
                                  }
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          }

                          @if (planShowSubsidyRow) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">補助金額</div>
                              <div class="pv-value">
                                @if (planForm.subsidyAmount !== null && planForm.subsidyAmount !== undefined) {
                                  <span class="pv-num">{{ formatPlanCurrency(planForm.subsidyAmount) }}円</span>
                                  @if (subsidyRate) {
                                    <span class="pv-inline-note">補助率 {{ subsidyRate }}</span>
                                  }
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          }
                        </section>
                      }

                      <!-- 案内方法 -->
                      @if (planShowGuideCard) {
                        <section class="pv-card" style="--pv-label-chars: 4">
                          <div class="pv-card-title">案内方法</div>

                          @if (planShowAnnouncementMethod) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">案内方法</div>
                              <div class="pv-value">
                                <div class="pv-chips" appStackOnWrap>
                                  @for (announce of getPlanMasterNameArray(planForm.announcementMethod, 'announcement_method'); track announce; let i = $index) {
                                    <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ announce }}</span>
                                  } @empty {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                              </div>
                            </div>
                          }

                          @if (planShowRecruitmentMethod) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">応募方法</div>
                              <div class="pv-value">
                                <div class="pv-chips" appStackOnWrap>
                                  @for (recruit of getPlanMasterNameArray(planForm.recruitmentMethod, 'recruitment_method'); track recruit; let i = $index) {
                                    <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ recruit }}</span>
                                  } @empty {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </section>
                      }
                    </div>

                    <!-- 課題と対策（いずれも枠で囲わない） -->
                    @if (planShowIssueCard) {
                      <section class="pv-card" style="--pv-label-chars: 4">
                        <div class="pv-card-title">課題と対策</div>

                        @if (planForm.implementationChallenges) {
                          <div class="pv-row stack">
                            <div class="pv-label">実施する際の課題</div>
                            <div class="pv-value"><div class="pv-text">{{ planForm.implementationChallenges }}</div></div>
                          </div>
                        }

                        @if (planForm.countermeasures) {
                          <div class="pv-row stack">
                            <div class="pv-label">対策</div>
                            <div class="pv-value"><div class="pv-text">{{ planForm.countermeasures }}</div></div>
                          </div>
                        }

                        @if (planShowWorkplaceSection) {
                          <div class="pv-row stack">
                            <div class="pv-label">該当職場の想定議題</div>
                            <div class="pv-value">
                              @if (planForm.workplaceExpectedIssues) {
                                <div class="pv-text">{{ planForm.workplaceExpectedIssues }}</div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                          <div class="pv-row stack">
                            <div class="pv-label">重点ヒアリング項目</div>
                            <div class="pv-value">
                              @if (planForm.keyHearingItems) {
                                <div class="pv-text">{{ planForm.keyHearingItems }}</div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowEffectivenessRow) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">効果測定</div>
                            <div class="pv-value">
                              @if (planForm.effectivenessMeasurement) {
                                {{ getPlanMasterName('effectiveness_measurement', planForm.effectivenessMeasurement) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                      </section>
                    }

                    <!-- その他（自組織のみ）。資料はリンクのため青字・青枠 -->
                    @if (planShowMaterialCard) {
                      <section class="pv-card" style="--pv-label-chars: 9">
                        <div class="pv-card-title">その他</div>

                        @if (planAttachments[1].length > 0) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">当日使用資料/教材</div>
                            <div class="pv-value">
                              <div class="pv-chips" appStackOnWrap>
                                @for (att of planAttachments[1]; track $index) {
                                  <span class="pv-chip file" [class.attachment-link]="att.downloadUrl" (click)="onDownloadPlanAttachment(att)">{{ att.fileName }}</span>
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planAttachments[2].length > 0) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">企画/検討資料</div>
                            <div class="pv-value">
                              <div class="pv-chips" appStackOnWrap>
                                @for (att of planAttachments[2]; track $index) {
                                  <span class="pv-chip file" [class.attachment-link]="att.downloadUrl" (click)="onDownloadPlanAttachment(att)">{{ att.fileName }}</span>
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planForm.memo) {
                          <div class="pv-row stack">
                            <div class="pv-label">メモ</div>
                            <div class="pv-value"><div class="pv-text">{{ planForm.memo }}</div></div>
                          </div>
                        }
                      </section>
                    }
                  }
                </div>
              }
            } @else if (activeDocumentTab === 'report') {
              @if (!planPreviewReady) {
                <div class="spinner">
                  <mat-spinner diameter="60"></mat-spinner>
                </div>
              } @else if (isOtherPreview && (reportForm.categoryId === 8 || reportForm.categoryId === 9)) {
                <div class="no-preview">
                  他組織に公開されません。
                </div>
              } @else {
                <div class="plan-preview-wrap pv">

                  <!-- 実施状況（色ぬりのラベル）とタイトル、カテゴリー、画像（自組織のみ・中央揃え） -->
                  <div class="pv-head">
                    <div class="pv-title-line">
                      @if (!isInitialStateReport) {
                        @if (reportForm.implementationStatus) {
                          <span class="pv-status" [class]="reportStatusClass">
                            {{ getPlanMasterName('report_implementation_status', reportForm.implementationStatus) }}
                          </span>
                        } @else {
                          <span class="unregistered">実施状況 未登録</span>
                        }
                      }
                      <h3 class="pv-title">
                        @if (planForm.title) {
                          {{ planForm.title }}
                        } @else {
                          <span class="unregistered">タイトル 未登録</span>
                        }
                      </h3>
                    </div>
                    <div class="pv-chips" appStackOnWrap>
                      @if (categoryMajorName) {
                        <span class="pv-major">{{ categoryMajorName }}</span>
                      }
                      @for (sub of getPlanMasterNameArray(planForm.categorySub, 'category_sub'); track sub; let i = $index) {
                        <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ sub }}</span>
                      } @empty {
                        <span class="unregistered">中分類 未登録</span>
                      }
                    </div>
                    @if (reportShowImages) {
                      <div class="image-preview-grid pv-images">
                        @for (att of attachments.image; track $index) {
                          <div class="image-preview-item">
                            @if (att.downloadUrl) {
                              <img [src]="att.downloadUrl" [alt]="att.fileName" class="image-preview-img"
                                   (click)="openLightbox(att.downloadUrl)">
                            } @else {
                              <div class="image-preview-placeholder">{{ att.fileName }}</div>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (lightboxUrl) {
                      <div class="lightbox-overlay" (click)="closeLightbox()">
                        <img [src]="lightboxUrl" class="lightbox-img" (click)="$event.stopPropagation()">
                      </div>
                    }
                  </div>

                  <!-- 参加者・自己評価（左）と参加者評価（右）。人数・点数などの数字は大きく出す -->
                  @if (reportShowParticipantCard || reportShowSelfEvalCard || reportShowEvaluationCard) {
                    <div class="pv-grid">
                      @if (reportShowParticipantCard || reportShowSelfEvalCard) {
                        <div class="pv-col">
                          @if (reportShowParticipantCard) {
                            <section class="pv-card" style="--pv-label-chars: 4">
                              <div class="pv-card-title">参加者</div>
                              <div class="pv-stats">
                                <div class="pv-stat">
                                  <div class="pv-stat-label">総数</div>
                                  @if (reportForm.participantTotal !== null && reportForm.participantTotal !== undefined) {
                                    <div class="pv-stat-value">{{ reportForm.participantTotal }}人</div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                                @if (showParticipantDetail) {
                                  <div class="pv-stat">
                                    <div class="pv-stat-label">新規</div>
                                    @if (reportForm.participantNew !== null && reportForm.participantNew !== undefined) {
                                      <div class="pv-stat-value">{{ reportForm.participantNew }}人</div>
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </div>
                                }
                              </div>
                              @if (showParticipantDetail) {
                                @if (reportAgeItems.length > 0) {
                                  <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                    <div class="pv-label">年代</div>
                                    <div class="pv-value">
                                      <div class="pv-chips" appStackOnWrap>
                                        @for (age of reportAgeItems; track age) {
                                          <span class="pv-chip">{{ age }}</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                                <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                  <div class="pv-label">女性比率</div>
                                  <div class="pv-value">
                                    @if (reportForm.femaleRatio) {
                                      {{ getPlanMasterName('report_female_ratio', reportForm.femaleRatio) }}
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </div>
                                </div>
                              }
                            </section>
                          }

                          @if (reportShowSelfEvalCard) {
                            <section class="pv-card" style="--pv-label-chars: 6">
                              <div class="pv-card-title">自己評価</div>
                              @if (reportForm.selfEvalScore) {
                                <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                  <div class="pv-label">点数</div>
                                  <div class="pv-value">{{ getPlanMasterName('report_self_eval_score', reportForm.selfEvalScore) }}</div>
                                </div>
                              }
                              @if (reportForm.selfEvalComment) {
                                <div class="pv-row stack">
                                  <div class="pv-label">コメント</div>
                                  <div class="pv-value"><div class="pv-text">{{ reportForm.selfEvalComment }}</div></div>
                                </div>
                              }
                              @if (reportForm.canRedo) {
                                <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                  <div class="pv-label">再実施の可否</div>
                                  <div class="pv-value">{{ getPlanMasterName('report_can_redo', reportForm.canRedo) }}</div>
                                </div>
                              }
                            </section>
                          }
                        </div>
                      }

                      @if (reportShowEvaluationCard) {
                        <div class="pv-col">
                          <section class="pv-card" style="--pv-label-chars: 7">
                            <div class="pv-card-title">参加者評価</div>
                            @if (showEvaluation) {
                              <div class="pv-stats">
                                <div class="pv-stat">
                                  <div class="pv-stat-label">総合点</div>
                                  @if (reportForm.participantEvalScore) {
                                    <div class="pv-stat-value">{{ getPlanMasterName('report_eval_score', reportForm.participantEvalScore) }}</div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                                @if (!isEvaluationUnrated) {
                                  <div class="pv-stat">
                                    <div class="pv-stat-label">評価収集数</div>
                                    @if (reportForm.evalCollectedCount !== null && reportForm.evalCollectedCount !== undefined) {
                                      <div class="pv-stat-value">{{ reportForm.evalCollectedCount }}</div>
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </div>
                                  @if (c !== 6) {
                                    <div class="pv-stat">
                                      <div class="pv-stat-label">収集率</div>
                                      <div class="pv-stat-value">{{ collectionRate }}</div>
                                    </div>
                                  }
                                }
                              </div>

                              @if (isEvaluationUnrated) {
                                <div class="pv-row stack">
                                  <div class="pv-label">未評価理由</div>
                                  <div class="pv-value">
                                    @if (reportForm.unevaluatedReason) {
                                      <div class="pv-text">{{ reportForm.unevaluatedReason }}</div>
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </div>
                                </div>
                              }

                              <!-- イベント各部：「イベント：○部」は固定で出す。タイトル・点数がともに空の部は枠ごと出さない。
                                   「イベント：○部」はどの画面幅でも左の列に置き（下に落とさない）、右にタイトル・点数を2行で出す（見出しなし） -->
                              @for (part of reportEvaluationParts; track part.label) {
                                <div class="pv-row pv-part-row">
                                  <div class="pv-label">{{ part.label }}</div>
                                  <div class="pv-value">
                                    @if (part.title) {
                                      <div class="pv-part-line">{{ part.title }}</div>
                                    }
                                    @if (part.score) {
                                      <div class="pv-part-line">{{ part.score }}</div>
                                    }
                                  </div>
                                </div>
                              }
                            }

                            @if (showUnderstanding && reportForm.understandingScore) {
                              <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                <div class="pv-label">理解度</div>
                                <div class="pv-value">{{ getPlanMasterName('report_understanding_score', reportForm.understandingScore) }}</div>
                              </div>
                            }

                            @if (showEvaluation) {
                              @if (reportForm.reAttendanceRate != null) {
                                <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                                  <div class="pv-label">再参加意向</div>
                                  <div class="pv-value">{{ reportForm.reAttendanceRate }}%</div>
                                </div>
                              }
                              @if (reportForm.participantOpinions) {
                                <div class="pv-row stack">
                                  <div class="pv-label">意見/感想</div>
                                  <div class="pv-value"><div class="pv-text">{{ reportForm.participantOpinions }}</div></div>
                                </div>
                              }
                            }
                          </section>
                        </div>
                      }
                    </div>
                  }

                  <!-- 実施状況など（有無だけ枠で囲い、コメントは見出しなしでその下に出す） -->
                  @if (!isInitialStateReport) {
                    <section class="pv-card" style="--pv-label-chars: 9">
                      <div class="pv-card-title">実施状況など</div>

                      @if (!isLimitedDisplay && showOrgActivity) {
                        <div class="pv-row stack">
                          <div class="pv-label">実施内容</div>
                          <div class="pv-value">
                            @if (reportForm.implementationContent) {
                              <div class="pv-text">{{ reportForm.implementationContent }}</div>
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                      }

                      @if (showProblem) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">問題の有無</div>
                          <div class="pv-value">
                            @if (getReportHasProblemabel()) {
                              <div class="pv-chips" appStackOnWrap><span class="pv-chip">{{ getReportHasProblemabel() }}</span></div>
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                          @if (reportForm.problemComment) {
                            <div class="pv-text pv-comment pv-below">{{ reportForm.problemComment }}</div>
                          }
                        </div>
                      }

                      <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                        <div class="pv-label">企画書からの変更点</div>
                        <div class="pv-value">
                          @if (getReportHasChangeFromPlan()) {
                            <div class="pv-chips" appStackOnWrap><span class="pv-chip">{{ getReportHasChangeFromPlan() }}</span></div>
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                        @if (reportForm.changeFromPlanComment) {
                          <div class="pv-text pv-comment pv-below">{{ reportForm.changeFromPlanComment }}</div>
                        }
                      </div>

                      @if (!isLimitedDisplay) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">実施方法</div>
                          <div class="pv-value">
                            @if (reportForm.implementationMethod) {
                              {{ getPlanMasterName('implementation_method', reportForm.implementationMethod) }}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                      }

                      @if (!isOtherPreview && !isLimitedDisplay && showStakeholderAndChallenges) {
                        <div class="pv-row stack">
                          <div class="pv-label">関係者情報</div>
                          <div class="pv-value">
                            @if (reportForm.stakeholderInfo) {
                              <div class="pv-text">{{ reportForm.stakeholderInfo }}</div>
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                      }

                      @if (!isLimitedDisplay) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">報告方法</div>
                          <div class="pv-value">
                            <div class="pv-chips" appStackOnWrap>
                              @for (method of getPlanMasterNameArray(reportForm.unionReportMethod, 'report_union_method'); track method; let i = $index) {
                                <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ method }}</span>
                              } @empty {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </section>
                  }

                  <!-- 実施結果など（いずれも枠で囲わない。改善する指標・成果目標は、結果との間に区切り線を入れない） -->
                  @if (reportShowResultCard) {
                    <section class="pv-card" style="--pv-label-chars: 6">
                      <div class="pv-card-title">実施結果など</div>

                      @if (!isLimitedDisplay && showImprovementResult) {
                        <div class="pv-group">
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">改善する指標</div>
                            <div class="pv-value">
                              <div class="pv-chips" appStackOnWrap>
                                @for (state of getPlanMasterNameArray(_rawImprovementState, 'improvement_indicator_state'); track state; let i = $index) {
                                  <span class="pv-chip num"><span class="priority-num">{{ i + 1 }}</span>{{ state }}</span>
                                } @empty {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          </div>
                          @if (!isInitialStateReport) {
                            <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                              <div class="pv-label">結果</div>
                              <div class="pv-value">
                                @if (reportForm.improvementResultRating) {
                                  <div class="pv-chips" appStackOnWrap>
                                    <span class="pv-chip">{{ getPlanMasterName('report_improvement_result', reportForm.improvementResultRating) }}</span>
                                  </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              @if (reportForm.improvementResultReason) {
                                <div class="pv-text pv-comment pv-below">{{ reportForm.improvementResultReason }}</div>
                              }
                            </div>
                          }
                        </div>
                      }

                      @if (!isLimitedDisplay && showOutcomeResult) {
                        <div class="pv-group">
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">成果目標</div>
                            <div class="pv-value">
                              @if (reportForm.improvementOutcomeText) {
                                <div class="pv-chips" appStackOnWrap>
                                  <span class="pv-chip">{{ reportForm.improvementOutcomeText }}</span>
                                </div>
                              }
                            </div>
                          </div>
                          @if (!isInitialStateReport) {
                            <div class="pv-row stack">
                              <div class="pv-label">結果</div>
                              <div class="pv-value">
                                @if (reportForm.implementationResult) {
                                  <div class="pv-text">{{ reportForm.implementationResult }}</div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }

                      @if (!isInitialStateReport && !isLimitedDisplay) {
                        @if (showStakeholderAndChallenges && reportForm.challengesNotes) {
                          <div class="pv-row stack">
                            <div class="pv-label">課題/気づき</div>
                            <div class="pv-value"><div class="pv-text">{{ reportForm.challengesNotes }}</div></div>
                          </div>
                        }

                        @if (showNextImprovement) {
                          <div class="pv-row stack">
                            <div class="pv-label">次回改善点</div>
                            <div class="pv-value">
                              @if (reportForm.nextImprovement) {
                                <div class="pv-text">{{ reportForm.nextImprovement }}</div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (showLaborNegotiation) {
                          <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                            <div class="pv-label">協議状況</div>
                            <div class="pv-value">
                              @if (reportForm.negotiationStatus) {
                                {{ getPlanMasterName('report_negotiation_status', reportForm.negotiationStatus) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>

                          @if (showAgreementContent) {
                            <div class="pv-row stack">
                              <div class="pv-label">合意内容</div>
                              <div class="pv-value">
                                @if (reportForm.agreementContent) {
                                  <div class="pv-text">{{ reportForm.agreementContent }}</div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          }

                          <div class="pv-row stack">
                            <div class="pv-label">会社側 主張/論理</div>
                            <div class="pv-value">
                              @if (reportForm.companyClaim) {
                                <div class="pv-text">{{ reportForm.companyClaim }}</div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>

                          <div class="pv-row stack">
                            <div class="pv-label">労組側 主張/論理</div>
                            <div class="pv-value">
                              @if (reportForm.unionClaim) {
                                <div class="pv-text">{{ reportForm.unionClaim }}</div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>

                          @if (reportForm.unresolvedPoints) {
                            <div class="pv-row stack">
                              <div class="pv-label">未整理論点/積み残し</div>
                              <div class="pv-value"><div class="pv-text">{{ reportForm.unresolvedPoints }}</div></div>
                            </div>
                          }
                        }
                      }
                    </section>
                  }

                  <!-- 費用：総額と想定との差額を横に並べる -->
                  @if (reportShowCostCard) {
                    <section class="pv-card" style="--pv-label-chars: 6">
                      <div class="pv-card-title">費用</div>
                      @if (reportForm.categoryId !== 10 || reportForm.actualTotalCost != null) {
                        <div class="pv-row pv-pair">
                          <div class="pv-pair-item">
                            <div class="pv-label">総額</div>
                            <div class="pv-value">
                              @if (reportForm.actualTotalCost !== null && reportForm.actualTotalCost !== undefined) {
                                {{ formatPlanCurrency(reportForm.actualTotalCost) }}円
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                          @if (reportForm.actualTotalCost != null && costDiff) {
                            <div class="pv-pair-item">
                              <div class="pv-label">想定との差額</div>
                              <div class="pv-value">{{ costDiff }}</div>
                            </div>
                          }
                        </div>
                      }
                      @if (reportForm.costDiffReason) {
                        <div class="pv-row stack">
                          <div class="pv-label">差額発生理由</div>
                          <div class="pv-value"><div class="pv-text">{{ reportForm.costDiffReason }}</div></div>
                        </div>
                      }
                    </section>
                  }

                  <!-- その他（自組織のみ）。資料はリンクのため青字・青枠 -->
                  @if (reportShowOtherCard) {
                    <section class="pv-card" style="--pv-label-chars: 6">
                      <div class="pv-card-title">その他</div>

                      @if (!isLimitedDisplay && showEvaluation && attachments.eval.length > 0) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">評価データ</div>
                          <div class="pv-value">
                            <div class="pv-chips" appStackOnWrap>
                              @for (att of attachments.eval; track $index) {
                                <span class="pv-chip file" [class.attachment-link]="att.downloadUrl" (click)="onDownloadPlanAttachment(att)">{{ att.fileName }}</span>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      @if (!isLimitedDisplay && attachments.deliverable.length > 0) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">成果物データ</div>
                          <div class="pv-value">
                            <div class="pv-chips" appStackOnWrap>
                              @for (att of attachments.deliverable; track $index) {
                                <span class="pv-chip file" [class.attachment-link]="att.downloadUrl" (click)="onDownloadPlanAttachment(att)">{{ att.fileName }}</span>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      @if (attachments.reportDoc.length > 0) {
                        <div class="pv-row pv-auto" appStackOnWrap=":scope > .pv-label, :scope > .pv-value">
                          <div class="pv-label">報告書資料</div>
                          <div class="pv-value">
                            <div class="pv-chips" appStackOnWrap>
                              @for (att of attachments.reportDoc; track $index) {
                                <span class="pv-chip file" [class.attachment-link]="att.downloadUrl" (click)="onDownloadPlanAttachment(att)">{{ att.fileName }}</span>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      @if (reportForm.memo) {
                        <div class="pv-row stack">
                          <div class="pv-label">メモ</div>
                          <div class="pv-value"><div class="pv-text">{{ reportForm.memo }}</div></div>
                        </div>
                      }
                    </section>
                  }
                </div>
              }
            }
          </div>

          <!-- 最終更新：SP（767px以下）では役職の前で改行して2行にする -->
          @if (showLastUpdated) {
          <div class="last-updated">
            @if (activeDocumentTab === 'plan'){
              <span class="last-updated-date">最終更新 {{
                getFormattedDate(
                  planForm.lastUpdatedAt || eventDetail?.draftedAccount.createdAt
                )
              }}</span>
              <span class="last-updated-user">{{
                planForm.lastUpdatedOfficialPositionName
                  || eventDetail?.draftedAccount?.position
              }} {{
                planForm.lastUpdatedName
                  || eventDetail?.draftedAccount?.name
              }}</span>
            } @else{
              <span class="last-updated-date">最終更新 {{
                getFormattedDate(
                  reportForm.lastUpdatedAt || eventDetail?.draftedAccount.createdAt
                )
              }}</span>
              <span class="last-updated-user">{{
                reportForm.lastUpdatedOfficialPositionName
                  || eventDetail?.draftedAccount?.position
              }} {{
                reportForm.lastUpdatedName
                  || eventDetail?.draftedAccount?.name
              }}</span>
            }
          </div>
          }
        </div>

        <mat-divider></mat-divider>

        <!-- 管理用メモ -->
        <div class="memo-section">
          <div class="memo-section-header">
            <h3 class="section-title">管理用メモ<span class="section-title-note">（企画書・報告書 共通）</span></h3>
            <!-- 更新中はグレーにして押せなくする（二重に送らないため） -->
            @if (canUpdateMemo) {
              <button
                mat-raised-button
                class="update-btn"
                [disabled]="memoSaving"
                (click)="onUpdateMemo()"
              >
                更新
              </button>
            }
          </div>
          <div class="memo-wrapper">
            <textarea
              class="memo-textarea"
              [(ngModel)]="memoContent"
              placeholder="メモを入力"
              maxlength="10000"
            ></textarea>
          </div>
          <div class="last-updated">
            <span class="last-updated-date">最終更新 {{ getFormattedDate(eventDetail.adminMemo.lastUpdatedAt) }}</span>
            <span class="last-updated-user">{{ eventDetail.adminMemo.lastUpdatedOfficialPositionName }} {{ eventDetail.adminMemo.lastUpdatedName }}</span>
          </div>
        </div>

        <!-- 承認セクション -->
        <div class="approval-section">
          <h3 class="section-title">承認</h3>

          <!-- 承認依頼ボタン -->
          @if (
            eventDetail.canRequestApproval &&
            eventDetail.isDrafter &&
            !(
              eventDetail.documentType === 'report' &&
              activeDocumentTab === 'plan'
            )
          ) {
            <div
              class="approval-request-area"
              [class.no-flow]="!eventDetail.approvalFlows?.length"
            >
              <button
                mat-raised-button
                class="approval-request-btn"
                (click)="onOpenApprovalRequest()"
                [disabled]="isSubmittingApproval || hasRequiredFieldsMissing"
              >
                @if (isSubmittingApproval) {
                  <mat-spinner diameter="20"></mat-spinner>
                } @else {
                  <span>承認依頼</span>
                }
              </button>
              @if (hasRequiredFieldsMissing) {
                <div class="required-error">
                  必須項目が未入力です。
                </div>
              }
            </div>
          }

          <!-- 承認フロー -->
          @if (eventDetail.approvalFlows?.length) {
            @for (flow of eventDetail.approvalFlows; track flow.flowId) {
              <div
                class="approval-panel"
                [class.inactive-flow]="!flow.isActive"
              >

                @for (step of flow.steps; track step.level) {
                  <div class="approval-row">

                    <div class="approval-level">
                      {{ step.level === 0 ? '起票' : step.level + '次承認' }}
                    </div>

                    <div class="approval-users">

                      @for (approver of step.approvers; track approver.id) {
                        @if (getStatus(step, approver.id); as statusInfo) {
                          <div class="approval-user-row">

                            <div class="status-area">
                              @if (
                                statusInfo.status !== 'submitted' &&
                                statusInfo.status !== 'reviewing' &&
                                statusInfo.status !== 'skipped'
                              ) {
                                <div class="status-icon">
                                  <span
                                    [class.status-approved]="statusInfo.status === 'approved'"
                                    [class.status-returned]="statusInfo.status === 'returned'"
                                  >
                                    {{ getApprovalStatusLabel(statusInfo.status) }}
                                  </span>
                                </div>
                              }
                            </div>

                            <div class="user-name">
                              @if (approver.position) {
                                <span class="position">{{ approver.position }}</span>
                              }{{ approver.name }}
                            </div>

                            <div class="user-affiliation">
                              @if (eventDetail.status === 'completed' ) {
                                @if (approver.organizations_text?.length) {
                                  {{ approver.organizations_text[0] }}
                                  @if (approver.organizations_text.length > 1) {
                                    など
                                  }
                                }
                              } @else{
                                @if (approver.affiliations?.length) {
                                  {{ approver.affiliations[0] }}
                                  @if (approver.affiliations.length > 1) {
                                    など
                                  }
                                }
                              }
                            </div>

                            <div class="action-date">
                              @if (
                                statusInfo.date &&
                                statusInfo.status !== 'reviewing'
                              ) {
                                {{ getStatusInfoFormattedDate(statusInfo.date) }}
                              }
                            </div>

                          </div>

                        }

                      }

                    </div>

                  </div>

                  @if (!$last) {
                    <mat-divider></mat-divider>
                  }

                }

                @if (
                  flow.isActive &&
                  (currentStep?.canApprove || currentStep?.canReturn)
                ) {
                  <div class="approval-buttons" appStackOnWrap>

                    @if (currentStep?.canReturn) {
                      <button
                        mat-raised-button
                        class="return-btn"
                        (click)="onReturn(currentStep)"
                      >
                        差戻し
                      </button>
                    }

                    @if (currentStep?.canApprove && currentStep?.level !== 9) {
                      <button
                        mat-raised-button
                        class="basicinfo"
                        (click)="onOpenApprovalRequest()"
                      >
                        次を選択して承認
                      </button>
                    }

                    @if (currentStep?.canApprove) {
                      <button
                        mat-raised-button
                        color="primary"
                        class="yes-btn"
                        (click)="onApprove(currentStep)"
                      >
                        決裁
                      </button>
                    }

                  </div>
                }

              </div>

            }

          }
        </div>
      }
    </div>
  </div>
}
